import Link from "next/link";

import { UnviewedIndicatorText } from "@/components/ui/unviewed-indicator-text";
import { useTrackAnalytics } from "@/hooks/analytics.hooks";
import type { Screener } from "@/types/screeners";
import type { PropsWithTableInfo } from "@/types/third-party";

export const JobTitleCell = ({
  info,
}: PropsWithTableInfo<Screener, string>) => {
  const track = useTrackAnalytics();
  const { id, unviewedSessionCount } = info.row.original;

  return (
    <Link
      href={`/screener/${id}`}
      className="block text-uw-purple w-full"
      onClick={() => {
        track("Screener Clicked", { screener_id: id });
      }}
    >
      <UnviewedIndicatorText
        indicatorText={`${unviewedSessionCount}`}
        primaryText={info.getValue()}
        showIndicatorText={unviewedSessionCount > 0}
      />
    </Link>
  );
};
